import { QueryParamsForGetRequest } from "@/utils/types";
import { AxiosRequestConfig } from "axios";
import {
  ContractsList,
  ContractsResponseSchema,
  getContractsEndpoint,
  http,
} from "@/services";

export const requestContractList = (
  data: QueryParamsForGetRequest,
  config?: AxiosRequestConfig,
) =>
  http.get<ContractsList>(
    getContractsEndpoint,
    data,
    config,
    undefined,
    ContractsResponseSchema,
  );
